import React from "react";
import { panelStore } from "main/header/panel/_stores/panelStore";
import { Panel } from "main/header/panel/Panel";
import { observer } from "mobx-react";

export const PanelObserver = observer(() => {
    return <Panel option={panelStore.option} />;
});
